/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DropdownButtonArrow/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import ArrowRight from 'DesignSystem/Svgs/ArrowRight/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function DropdownButtonArrow({
  children,
  viewPath = "/DesignSystem/DropdownButtonArrow",
  borderBottomLeftRadius = 6,
  borderBottomRightRadius = 6,
  borderTopLeftRadius = 6,
  borderTopRightRadius = 6,
  marginTop = 0,
  marginRight = 0,
  marginLeft = 0,
  marginBottom = 0,
  onClick,
  isDisabled,
  text = "Change",
  color = "rgba(19,126,197,1)",
  fontSize = 12
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled})
  return (<React.Fragment
>
<button
  data-testid="DropdownButtonArrow.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 disabled={isDisabled}
 style={{'--bblr-1-3g8iN': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-2-3g8iN': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-3-3g8iN': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-4-3g8iN': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--mt-5-3g8iN': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-6-3g8iN': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-7-3g8iN': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mb-8-3g8iN': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom}}
 className={`views-block ${styles.Horizontal}`}
>
<span
  data-testid="DropdownButtonArrow.Text"
  data-view-path={viewPath}
 style={{'--c-9-3g8iN': color,'--fs-10-3g8iN': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--td-11-3g8iN': isHovered ? "underline" : "none"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
<div
  data-testid="DropdownButtonArrow.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<ArrowRight
  viewPath={`${viewPath}/ArrowRight`}
 width={12}
 height={12}
 stroke="rgba(19,126,197,1)"
/>
</div>
</button>
{children}
</React.Fragment>)
}